// Legacy "north_star" block — superseded by the auto-rendered North Star guide card under every hero.
// Kept so old layouts still load; renders nothing.
export const NorthStarBlock = () => null;

export default NorthStarBlock;
